module.exports = __webpack_public_path__ + "clock.jpg?06bea2702d125ce3c30a64323916c60c";